import styled from "styled-components";

export default styled.div`
  .test-page {
    margin-top: 100px;

    .button-container {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: auto;
      gap: 10px;
      justify-content: center;
      align-items: center;
      padding: 1rem;
    }
  }
`;
